var map = {
	"./apple.svg": 13623,
	"./discord.svg": 91035,
	"./drm-free.svg": 28429,
	"./epic.svg": 32465,
	"./gog.svg": 83601,
	"./google.svg": 76290,
	"./linux.svg": 88512,
	"./nintendo.svg": 23254,
	"./origin.svg": 60275,
	"./playstation.svg": 29894,
	"./steam.svg": 64232,
	"./unrealEngine.svg": 94808,
	"./uplay.svg": 70404,
	"./windows.svg": 15566,
	"./xbox.svg": 17791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88051;